import React from 'react';
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container/Container';
import Box from '@mui/material/Box/Box';
import Stack from '@mui/material/Stack/Stack';
import Typography from '@mui/material/Typography/Typography';
import { useTheme } from '@mui/material/styles';

export const AppFooter = () => {
    const theme = useTheme();

    return (
        <Box component="footer" className="app-footer no-print-no-display" sx={{
            mt: 6,
            borderTop: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper
        }}>
            <Container>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} sx={{ py: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        {theme.brand.isCustom ? 'Powered by ' : '© ' + new Date().getFullYear() + ' '}
                        <Link to="/">Hack in a Box</Link>
                    </Typography>
                    <Stack direction="row" spacing={3}>
                        <Typography variant="body2"><Link to="/how/to">How-to guides</Link></Typography>
                        <Typography variant="body2"><Link to="/pricing">Pricing</Link></Typography>
                        <Typography variant="body2"><Link to="/privacy">Privacy</Link></Typography>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    )
}
